import { render, staticRenderFns } from "./ActivityShare.vue?vue&type=template&id=aff87a42&scoped=true&lang=html&"
import script from "./ActivityShare.vue?vue&type=script&lang=js&"
export * from "./ActivityShare.vue?vue&type=script&lang=js&"
import style0 from "./ActivityShare.vue?vue&type=style&index=0&id=aff87a42&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff87a42",
  null
  
)

export default component.exports